import { createApiClient } from '@/api/apiClienttFactory'

import { APP_CONFIG } from '../../env-cmdrc'

export const samApiClient = createApiClient({
  baseDevUrl: APP_CONFIG.SAM_BACKEND_URL,
  baseProdPath: 'api/',
})

export const samFotaApiClient = createApiClient({
  baseDevUrl: APP_CONFIG.SAM_FOTA_BACKEND_URL,
  baseProdPath: 'api/fota/',
})
